import BaseWidget from 'components/BaseWidget/BaseWidget';
import DeviceSettingsModals from 'features/integrations/features/ConnectedDevices/features/DeviceSettingsModals/DeviceSettingsModals';
import { selectIntegrationFetching } from 'features/integrations/state/selectors/integrationSelectors';
import { useSelector } from 'react-redux';
import DeviceGraphWidget from './widgets/DeviceGraphWidget';
import DeviceListWidget from './widgets/DeviceListWidget';
import DeviceMapWidget from './widgets/DeviceMapWidget';
import FloodMapWidget from './widgets/FloodMapWidget';

const ConnectedDevicesWidget = ({
  widgetType,
  dimensions,
  widget,
  setShowCurrentDevice,
  setShowDeviceSettings,
  selectedGroup,
  setSelectedGroup,
}) => {
  const fetching = useSelector(selectIntegrationFetching);

  return (
    <>
      <BaseWidget
        widgetType={widgetType}
        dimensions={dimensions}
        isLoading={fetching}
        renderers={{
          list: () => (
            <DeviceListWidget
              setShowCurrentDevice={setShowCurrentDevice}
              setShowDeviceSettings={setShowDeviceSettings}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
            />
          ),
          graph: () => (
            <DeviceGraphWidget
              setShowCurrentDevice={setShowCurrentDevice}
              selectedGroup={selectedGroup}
              widget={widget}
            />
          ),
          map: () => (
            <DeviceMapWidget
              setShowCurrentDevice={setShowCurrentDevice}
              setShowDeviceSettings={setShowDeviceSettings}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
              filtersCompact={dimensions?.[0] === 1 && dimensions?.[1] === 1}
            />
          ),
          awareFloodMap: () => <FloodMapWidget />,
        }}
        route={widgetType === 'list' ? null : 'getNodes'}
      />
      <DeviceSettingsModals />
    </>
  );
};

export default ConnectedDevicesWidget;
